import { render, staticRenderFns } from "./SuccessSubmitForm4.vue?vue&type=template&id=ae0cbdf4&scoped=true"
import script from "./SuccessSubmitForm4.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0cbdf4",
  null
  
)

export default component.exports